import RestService from '@/modules/backend/RestService';
import { EditCounterData } from '@/modules/backend/Dto/EditCounterData';
import { Counter } from '../Entities/Counter';
import { plainToClass } from 'class-transformer';
import { CreateCounterData } from '@/modules/backend/Dto/CreateCounterData';

export default class Counters {
  private readonly rest: RestService;
  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async Create(data: CreateCounterData): Promise<Counter> {
    const item = await this.rest.post('/api/v1/counter', data);
    return plainToClass(Counter, item);
  }

  public async Edit(payload: EditCounterData): Promise<Counter> {
    const item = await this.rest.put('/api/v1/counter', payload);
    return plainToClass(Counter, item);
  }

  public async Fetch(accountId: number): Promise<Counter[]> {
    const result = await this.rest.get<unknown[]>(`/api/v1/account/${accountId}/counters`);
    return plainToClass(Counter, result);
  }

  public async GetOne(counterId: number): Promise<Counter> {
    const counter = await this.rest.get(`/api/v1/counter/${counterId}`);
    return plainToClass(Counter, counter);
  }
}
